module.exports = __webpack_public_path__ + "img/mobilebg.028a5187.jpg";